<template>
  <div class="asc-fault-monitor-detail-item-detail">
    <asc-details-item
      v-for="(detail, index) in getDetails"
      :key="index"
      :title="detail.title"
      :value="detail.value"
    ></asc-details-item>
  </div>
</template>

<script>
import AscDetailsItem from './AscDetailsItem'

export default {
  name: 'AscFaultMonitorDetailItemDetail',

  components: { AscDetailsItem },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getDetails() {
      const items = []
      items.push(this.getAttendedItems())
      items.push(this.getUnattendedItems())
      items.push(this.getMemoItem())
      items.push(this.getAltNameItem())
      return items
    },
  },

  methods: {
    getAttendedItems() {
      return {
        title: 'Attended',
        value: [
          this.item &&
          this.item.attendedMessage &&
          this.item.attendedMessage.eicasMessage
            ? 'EICAS Msg: ' + this.item.attendedMessage.eicasMessage
            : '',
          this.item &&
          this.item.attendedMessage &&
          this.item.attendedMessage.maintenanceMessage
            ? 'Maint Msg: ' + this.item.attendedMessage.maintenanceMessage
            : '',
        ],
      }
    },
    getUnattendedItems() {
      return {
        title: 'Unattended',
        value: [
          this.item &&
          this.item.unAttendedMessage &&
          this.item.unAttendedMessage.eicasMessage
            ? 'EICAS Msg: ' + this.item.unAttendedMessage.eicasMessage
            : '',
          this.item &&
          this.item.unAttendedMessage &&
          this.item.unAttendedMessage.maintenanceMessage
            ? 'Maint Msg: ' + this.item.unAttendedMessage.maintenanceMessage
            : '',
        ],
      }
    },
    getMemoItem() {
      return {
        title: 'Memo',
        value: this.item && this.item.memo ? this.item.memo : '',
      }
    },
    getAltNameItem() {
      return {
        title: 'Alternate Name',
        value:
          this.item && this.item.alternateName ? this.item.alternateName : '',
      }
    },
  },
}
</script>
